// Copyright (c) 2019-26 Stax·ai, Inc.
// See LICENSE.md file in project root directory

// Thin wrappers over the legacy /tpa/plansync/* routes (plan-sync plan 2).
// The Sync settings page and the Plan Editor CX Review mode read sync state
// through these — never through props.team.sync.

import api from '../api';

// {success, connected, status: "active"|"error", cxTeamName?, lastSyncAt?, lastError?, pendingCount}
export const getStatus = () => api.get('/tpa/plansync/status', {}, false, {}, true);

// {success, pending: [{_id, cxPlanId, payload, receivedAt, suggestion?}]}
export const getPending = () => api.get('/tpa/plansync/pending', {}, false, {}, true);

// body: {action: "link"|"create"|"dismiss"|"bulkAcceptSuggested", pendingId?, planId?, internalPlanId?, directory?}
// api.post surfaces server error strings via its centralized toast.
export const resolve = (body) => api.post('/tpa/plansync/resolve', body);

// Admin session only.
export const unlink = () => api.post('/tpa/plansync/unlink');

// "just now" / "12m ago" / "3h ago" / "5d ago"; "" for missing/invalid input.
export const relativeTime = (iso) => {
    if (!iso) return "";
    const ms = Date.now() - Date.parse(iso);
    if (isNaN(ms) || ms < 0) return "just now";
    const min = Math.floor(ms / 60000);
    if (min < 1) return "just now";
    if (min < 60) return min + "m ago";
    const hr = Math.floor(min / 60);
    if (hr < 24) return hr + "h ago";
    return Math.floor(hr / 24) + "d ago";
};
